import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { createContext, useContext, useState } from 'react';

import styles from './Tabs.module.scss';

const TabContext = createContext();
const cx = classnames.bind(styles);

export const Tabs = ({ children, defaultSelected }) => {
  const [selected, setSelected] = useState(defaultSelected);
  return (
    <TabContext.Provider value={{ selected, setSelected }}>
      <div className={styles['tab-container']}>{children}</div>
    </TabContext.Provider>
  );
};

export const TabItems = ({ children, renderActionButton }) => {
  return (
    <div className={styles['tab-items']}>
      {children}
      {renderActionButton && (
        <div className={styles['action-button']}>{renderActionButton()}</div>
      )}
    </div>
  );
};

export const TabItem = ({ actionButton, id, name }) => {
  const { selected, setSelected } = useContext(TabContext);
  const isSelected = selected === id;
  const cls = cx('tab-item', {
    'action-button': actionButton,
    selected: isSelected
  });
  const brandClass = classnames({
    'branded-selected': isSelected
  });
  return (
    <button
      className={`${cls} ${brandClass}`}
      id={id}
      onClick={() => setSelected(id)}
    >
      {name}
    </button>
  );
};

export const TabContent = props => {
  const { selected } = useContext(TabContext);
  const { name, children } = props;
  const showContent = selected === name;
  return (
    showContent && (
      <div className={styles['tab-content']} id="tab-content">
        {children}
      </div>
    )
  );
};

Tabs.propTypes = {
  children: PropTypes.node,
  defaultSelected: PropTypes.string
};

TabItems.propTypes = {
  children: PropTypes.node,
  renderActionButton: PropTypes.func
};

TabItem.propTypes = {
  actionButton: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string
};

TabContent.propTypes = {
  children: PropTypes.node,
  name: PropTypes.string
};
